import { Component, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ILoginData } from '@app/lib/models/login.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,   // Added for Mobile
    MatButtonModule  // Added for Mobile
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  userData: WritableSignal<ILoginData | null> = signal(null);

  constructor(
    private authService: AuthService, 
    private router: Router, 
    private dialog: MatDialog
  ) {
    this.authService.user
      .pipe(takeUntilDestroyed())
      .subscribe((user => {
        this.userData.set(user);
      }));
  }

  logoutHandler() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Logout',
        message: 'Are you sure you want to log out?',
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
      width: '350px'
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

  getUserRole() {
    const user = this.userData();
    if (user?.courtId != null && user.courtId === 12) { 
      const roleShortName = user?.roleDTOList?.[0]?.roleShortName?.toLowerCase();
      if (roleShortName === 'judge') {
          return 'MEMBER';
      } else if (roleShortName === 'hchair') {
          return 'CHAIRMAN';
      }
    }
    return user?.roleDTOList?.[0]?.roleShortName ?? '';
  }

  navigateToChangePassword() {
    this.router.navigate(['/reset-password']);
  }
}